// extracted by mini-css-extract-plugin
module.exports = {"dcolor":"var(--dcolor)","fcolor":"var(--fcolor)","menuActiveText":"#f4f4f5"};